import { UserUI } from '@src/models';

import { AddMemberModel } from '../types';

export const mapUserUIToAddMemberModel = (users: Array<UserUI>): Array<AddMemberModel> => {
  return users
    .filter(user => user.id && user.fullName)
    .map(user => {
      return {
        userId: user.id!,
        userName: user.fullName!,
      };
    });
};
